import React from 'react';
import { motion } from 'framer-motion';
const nodes = [{
  cx: 120,
  cy: 300,
  r: 4
}, {
  cx: 230,
  cy: 210,
  r: 5
}, {
  cx: 330,
  cy: 250,
  r: 4
}, {
  cx: 410,
  cy: 140,
  r: 6
}];
export function HeroOrnament() {
  return <div aria-hidden="true" className="decor pointer-events-none absolute -right-24 top-6 hidden h-[460px] w-[560px] text-sage lg:block" data-id="element-27" data-mp="solazgvfer4o">
      <svg viewBox="0 0 560 460" fill="none" className="h-full w-full" data-id="element-28" data-mp="joybj0m9bve9">
        <circle cx="380" cy="220" r="200" stroke="currentColor" strokeOpacity="0.28" data-id="element-29" data-mp="jn525dk9ex2k" />
        <circle cx="380" cy="220" r="150" stroke="currentColor" strokeOpacity="0.22" strokeDasharray="2 6" data-id="element-30" data-mp="eott351sgqle" />
        <circle cx="380" cy="220" r="96" stroke="currentColor" strokeOpacity="0.3" data-id="element-31" data-mp="9t4q0rqk8rkc" />
        <motion.path d="M120 300 C 170 300, 190 210, 230 210 S 300 250, 330 250 S 380 140, 410 140" stroke="currentColor" strokeWidth="1.25" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 1.8,
        ease: [0.22, 1, 0.36, 1],
        delay: 0.4
      }} data-id="element-32" data-mp="5r9opn8mqe6k" />
        {nodes.map((n, i) => <motion.circle key={i} cx={n.cx} cy={n.cy} r={n.r} className={i === nodes.length - 1 ? 'fill-sage-deep' : 'fill-ivory'} stroke="currentColor" strokeWidth="1.25" initial={{
        opacity: 0,
        scale: 0.4
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6 + i * 0.25
      }} style={{
        transformOrigin: `${n.cx}px ${n.cy}px`
      }} data-id="element-33" data-mp="1qo0kz4lbk302" data-mpi={i} />)}
        <line x1="410" y1="140" x2="470" y2="80" stroke="currentColor" strokeOpacity="0.4" data-id="element-34" data-mp="1vl0tdm5n5huc" />
        <line x1="462" y1="80" x2="478" y2="80" stroke="currentColor" strokeOpacity="0.4" data-id="element-35" data-mp="1zmvuoqnknv84" />
      </svg>
    </div>;
}